import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgbDropdownModule, NgbNavModule, NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { SimplebarAngularModule } from "simplebar-angular";
import { LanguageService } from "../core/services/language.service";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";

// Component pages
import { LayoutComponent } from "./layout.component";
import { VerticalComponent } from "./vertical/vertical.component";
import { TopbarComponent } from "./topbar/topbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { RightsidebarComponent } from "./rightsidebar/rightsidebar.component";
import { HorizontalComponent } from "./horizontal/horizontal.component";
import { HorizontalTopbarComponent } from "./horizontal-topbar/horizontal-topbar.component";
import { TwoColumnComponent } from "./two-column/two-column.component";
import { TwoColumnSidebarComponent } from "./two-column-sidebar/two-column-sidebar.component";
import { ModalComponentsModule } from "../shared/modal-components/modal-components.module";
import { ServiceProviderModalComponent } from "../pages/users/service/components/service-provider-modal/service-provider-modal.component";
import { CartModalComponent } from "../pages/users/e-delivery/components/cart-modal/cart-modal.component";
import { AddressModalComponent } from "../shared/modal-components/address-modal/address-modal.component";
import { CitySelectorComponent } from "../shared/shared-components/city-selector/city-selector.component";

@NgModule({
  declarations: [
    LayoutComponent,
    VerticalComponent,
    TopbarComponent,
    SidebarComponent,
    RightsidebarComponent,
    HorizontalComponent,
    HorizontalTopbarComponent,
    TwoColumnComponent,
    TwoColumnSidebarComponent,
    CitySelectorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgbNavModule,
    SimplebarAngularModule,
    TranslateModule,
    NgbCollapseModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ModalComponentsModule,
    CartModalComponent,
    ServiceProviderModalComponent,
    AddressModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [LanguageService]
})
export class LayoutsModule {}
